/* unplugin-vue-components disabled */import { render } from "./icon-fav.vue?vue&type=template&id=52f34477"
import script from "./icon-fav.vue?vue&type=script&lang=js"
export * from "./icon-fav.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/icon-fav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52f34477"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52f34477', __exports__)) {
    api.reload('52f34477', __exports__)
  }
  
  module.hot.accept("./icon-fav.vue?vue&type=template&id=52f34477", () => {
    api.rerender('52f34477', render)
  })

}


export default __exports__